/* Loading functions */
function addLoader(id) {
    $(id).addClass('loading');
}

function removeLoader(id) {
    setTimeout(function () {
        $(id).removeClass('loading');
    }, 500);

}

function priceToNumber(price) {
    var number = Number(price.replace(/[^0-9\.-]+/g, "")) * 100;
    return number;
}

function numberToPrice(number) {
    var price = (number / 100).toFixed(2);
    // Create our number formatter.
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'GBP'
    });

    return formatter.format(price);
}

function checkForAttr(attr) {
    if (typeof attr !== typeof undefined && attr !== false) {
        return 1;
    } else {
        return 0;
    }
}

var checkRequiredExtra;

function requiredExtra(check) {
    if (check == 1) {
        checkRequiredExtra = 1;
    } else {
        checkRequiredExtra = 0
    }

}

Shopify.queue = [];

Shopify.moveAlong = function () {
    // If we still have requests in the queue, let's process the next one.
    if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        Shopify.addItem(request.variantId, request.quantity, Shopify.moveAlong);
    } else {
        $('#add-toCart').addClass('added');
        $('#add-toCart').attr('value', 'Product Added');
        $('#add-toCart').attr('disabled', true);
        setTimeout(function () {
            var magnificPopup = $.magnificPopup.instance;
            if (typeof magnificPopup !== 'undefined') {
                magnificPopup.close();
            }
            $('#go-toCart').addClass('show');
            $('#myBasket').modal('show');
        }, 300)
    }
    // If the queue is empty, we will redirect to the cart page.
};

Shopify.addItem = function (id, qty, properties, callback) {
    var params = {
        quantity: qty,
        id: id
    };
    if (properties != false) {
        params.properties = properties;
    }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: params,
        success: function () {
            if (typeof callback === 'function') {
                callback();
            }
        },
        error: function () {
        }
    });
}

function updateTotal(id) {

    Shopify.getCart(function (data) {
        console.log(data.total_price);
    });
    hideRemoved(id);
}

function hideRemoved(id) {

    $('ul[data-id="' + id + '"]').addClass('hide');
    var remaining = $('ul.type-extra:visible, ul.type-product:visible').length;
    if (remaining < 1) {
        $('.cart_tbl form').addClass('hide');
        $('.custom.empty-cart-message').removeClass('hide');
    }
}

function removeItem(id) {

    jQuery.post('/cart/update.js', "updates[" + id + "]=0", "success=" + updateTotal(id));
    hideRemoved(id);
}

function removeItems(ids) {
    var arr1 = ids, arr2 = [];
    var obj = {};

    for (i = 0; i < arr1.length; i++) {
        obj[arr1[i]] = 0;
    }

    arr2['updates'] = obj
    var data = {
        updates: arr2['updates']
    }

    jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function() {
            ids.forEach(id => hideRemoved(id));
        }
    });
}

function push_to_queue(variantID, quantity, properties) {
    Shopify.queue.push({
        variantId: variantID,
        quantity: quantity,
        properties: properties
    });
}

function updateCartIcon(num) {

    var cartItemsNum = Number($('.navbar-right .cart-icon .count').text());

    $('.navbar-right .cart-icon .count, .navbar-header .cart-icon .count').remove();

    var newNum = cartItemsNum + num;

    $('.navbar-right .cart-icon, .navbar-header .navbar-cart.cart-popup .cart-icon').prepend('<span class="count">' + newNum + '</span>');
}

function truncateString(str, n) {
    if (str.length > n) {
        return str.substring(0, n) + "...";
    } else {
        return str;
    }
}

$(document).ready(function () {

    var attr,
        size,
        productName,
        productPrice,
        productSize,
        productImage,
        counter,
        extrasCounter,
        addedExtrasCounter,
        prodRegPrice,
        regPrice,
        totalPrice,
        totalRegPrice,
        rawPrice,
        regTotalPrice,
        deselectedPrice,
        clearedPrice,
        selectedPrice,
        newPrice,
        realPrice,
        priceWithCurrency,
        selectedVariant,
        selectedOption,
        property;

    /* function on selected variant */

    $('.product-variant').click(function () {

        addLoader('#product-extras');

        addLoader('#product-add');

        if (checkRequiredExtra == 1) {
            $('#add-toCart').attr('value', 'Select extra');
            $('#add-toCart').removeClass('added');
            $('#add-toCart').attr('disabled', true);
        } else {
            $('#add-toCart').attr('value', 'Add to Basket');
            $('#add-toCart').removeClass('added');
            $('#add-toCart').attr('disabled', false);
        }

        // $('.product-page-qty .qty_btn a').removeClass('disabled', false)
        $('.product-page-qty .txtbox').val(1)
        /* clear old selections and add the new */

        $('#go-toCart').removeClass('show');
        $(this).siblings().removeClass('selected');
        $('.product-extra').removeClass('selected').removeAttr('chosen');

        $(this).addClass('selected');

        $('.extras-wrapper').removeClass('hide');

        $('.no-selection').addClass('hide');

        $('#sale-price').text($(this).find('.price').text());

        /* checking for regular price */

        prodRegPrice = $(this).attr('reg-price');

        if (checkForAttr(prodRegPrice) == 1) {

            $('#regular-price').text(prodRegPrice);

            $('#regular-price').parents('.regular-wrapper').removeClass('hide');

        } else {

            $('#regular-price').parents('.regular-wrapper').addClass('hide');

        }

        size = $(this).data('size').toLowerCase().replace(/ /g, '-');
        var productId = $(this).attr('product-id');

        /* finding the extras that match to the selection */

        counter = 0;
        if(productId) {
            $('.button-extras-' + productId).prop("disabled", false); // Element(s) are now enabled.
        }
        $('.product-extra').each(function () {

            attr = $(this).attr('data-' + size);

            if (checkForAttr(attr) !== 0) {

                $(this).removeClass('hide');

                rawPrice = attr.split('|')[1];

                $(this).find('.price').text(rawPrice);

                counter++;

            } else {

                $(this).addClass('hide');

            }
        })
        /* show message if there are no extras for selected variant */

        if (counter < 1) {

            $('.no-extras').removeClass('hide');

        } else {

            $('.no-extras').addClass('hide');

        }

        removeLoader('#product-extras');

        removeLoader('#product-add');

    });

    /* functon for choosing extras */

    $('.product-extra').click(function () {
        addLoader('#product-add');
        if (checkRequiredExtra == 1) {

            if (!$(this).hasClass('selected')) {
                $('#add-toCart').attr('value', 'Add to Basket');
                $('#add-toCart').removeClass('added');
                $('#add-toCart').removeAttr('disabled');

            } else {
                if ($('.product-extra.selected').length < 1) {
                    $('#add-toCart').attr('value', 'Select extra');
                    $('#add-toCart').removeClass('added');
                    $('#add-toCart').attr('disabled', true);
                }
            }
        } else {
            $('#add-toCart').attr('value', 'Add to Basket');
            $('#add-toCart').removeClass('added');
            $('#add-toCart').removeAttr('disabled');
        }
        /* money calculations */


        totalPrice = priceToNumber($('#sale-price').text());

        

        
        if ($(this).hasClass('selected')) {

            deselectedPrice = priceToNumber($(this).find('.price').text());

        }
        
        else {

            deselectedPrice = 0;

        }
        

        clearedPrice = totalPrice - deselectedPrice;

        /* check if option is selected or deselected */

        $(this).attr('chosen', $(this).attr('data-' + size).split('|')[0]);

        regPrice = $(this).attr('data-' + size).split('|')[2];

        if (regPrice !== null && regPrice !== '') {

            regPrice = priceToNumber($(this).attr('data-' + size).split('|')[2]);

        } else {

            regPrice = priceToNumber($(this).find('.price').text());

        }

        if (!$(this).hasClass('selected')) {

            selectedPrice = priceToNumber($(this).find('.price').text());

            newPrice = selectedPrice + clearedPrice;

            attr = $('.product-variant.selected').attr('reg-price');

            if (checkForAttr(attr) !== 0) {

                regTotalPrice = priceToNumber(attr) + regPrice;

                $('#regular-price').text(numberToPrice(regTotalPrice));

            } else if (regPrice > selectedPrice) {

                regTotalPrice = priceToNumber($('.product-variant.selected .price').text()) + regPrice;

                $('#regular-price').text(numberToPrice(regTotalPrice));

                $('.regular-wrapper').removeClass('hide');

            } else {

                $('.regular-wrapper').addClass('hide');

            }

        } else {
            newPrice = clearedPrice;
            

            $(this).removeAttr('chosen');

            
            regPrice = $(this).attr('data-' + size).split('|')[2];

            if (regPrice !== null && regPrice !== '') {

                regPrice = priceToNumber(regPrice);
                if (checkForAttr(attr) == 0) {
                    $('.regular-wrapper').addClass('hide');

                }
            } else {

                regPrice = priceToNumber($(this).attr('data-' + size).split('|')[1]);

                attr = $('.product-variant.selected').attr('reg-price');


                if (checkForAttr(attr) == 0) {
                    $('.regular-wrapper').addClass('hide');

                }
            }
        }

        priceWithCurrency = numberToPrice(newPrice);

        $('#sale-price').text(priceWithCurrency);

        

        


        

        $(this).toggleClass('selected');

        

        removeLoader('#product-add');
        if (checkForAttr($('.product-variant.selected').attr('reg-price')) !== 0) {
            var totalExtras = 0;
            $('.product-extra.selected').each(function () {
                totalExtras = totalExtras + priceToNumber($(this).find('.price').text());
            })
            regTotalPrice = priceToNumber($('.product-variant.selected').attr('reg-price')) + totalExtras;
        }
        $('#regular-price').text(numberToPrice(regTotalPrice));

    });

    $('#add-toCart, .add-toCart').click(function (e) {
        counter = 0;
        e.preventDefault();

        productName = $('h1[itemprop="name"]').text() + ' ' + $('.product-variant.selected').data('size') + $('.product-variant.selected .cm-size').text();
        selectedVariant = $('.product-variant.selected').attr('variant-id');
        push_to_queue(selectedVariant, 1, '');

        extrasCounter = 0;
        addedExtrasCounter = 0;
        $('.product-extra.selected').each(function () {
            extrasCounter++;
            selectedOption = $(this).attr('chosen');
            push_to_queue(selectedOption, 1, '');
        })

        Shopify.moveAlong();
        var numOfAdded = extrasCounter + 1;

        updateCartIcon(numOfAdded);

    });

    /////////////////////////////////////
    //  START: Quick View
    /////////////////////////////////////

    $(".product-page-qty .minus_btn").click(function () {
        var inputEl = $(this).parent().siblings('.txtbox');
        var qty = inputEl.val(); qty--;
        if (qty <= 1) qty = 1;
        var price = $('.product-variant.selected').find('.price').data('price');
        var totalPrice = parseFloat(price) * parseFloat(qty);
        $('#sale-price').text(numberToPrice(totalPrice));
        inputEl.val(qty);
    })


    $(".product-page-qty .plus_btn").click(function () {
        var inputEl = $(this).parent().siblings('.txtbox');
        var qty = inputEl.val(); qty++;
        var price = $('.product-variant.selected').find('.price').data('price');
        var totalPrice = parseFloat(price) * parseFloat(qty);
        $('#sale-price').text(numberToPrice(totalPrice));
        inputEl.val(qty);
    })
    /////////////////////////////////////
    //  ENS: Quick View
    /////////////////////////////////////
    // END: Custom

    $('#go-toCart').click(function () {
        var url = "/cart";
        $(location).attr('href', url);
    });

    //create the slider
    $('.cd-testimonials-wrapper').flexslider({
        selector: ".cd-testimonials > li",
        animation: "slide",
        controlNav: false,
        directionNav: true,
        slideshow: false,
        smoothHeight: false,
        prevText: "",
        nextText: "",
        start: function () {
            $('.cd-testimonials').children('li').css({
                'opacity': 1,
                'position': 'relative'
            });
        }
    });

    // tiny helper function to add breakpoints
    function getGridSize() {
        return (window.innerWidth < 600) ? 2 :
            (window.innerWidth < 900) ? 3 : 4;
    }

    // create the slider
    $('.cd-prefooter-wrapper-test').flexslider({
        selector: ".cd-prefooter > div.block-wrapper",
        animation: "slide",
        controlNav: false,
        directionNav: true,
        slideshow: false,
        smoothHeight: false,
        touch: true,
        mousewheel: true,
        itemWidth: "25vw",
        minItems: getGridSize(), // use function to pull in initial value
        maxItems: getGridSize(), // use function to pull in initial value
        start: function () {
            $('.cd-prefooter').children('div.block-wrapper').css({
                'opacity': 2
            });
        }
    });

    $('.cd-prefooter').slick({
        dots: false,
        infinite: false,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false
                }
            }
        ]
    });

    $('.rangs-slider-for').slick({
        dots: false,
        infinite: false,
        arrows: false,
        fade: true,
        cssEase: 'linear',
        speed: 500,
        asNavFor: '.rangs-slider-nav',
        adaptiveHeight: true,
        slidesToShow: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    infinite: true,
                    arrows: true,
                    prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
                    nextArrow: '<div class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'
                }
            },
            {
                breakpoint: 600,
                settings: {
                    infinite: true,
                    arrows: true,
                    prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
                    nextArrow: '<div class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'
                }
            }
        ]
    });

    $('.rangs-slider-nav').slick({
        asNavFor: '.rangs-slider-for',
        focusOnSelect: true,
        dots: false,
        infinite: false,
        arrows: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 6,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    centerMode: true,
                    infinite: true,
                    centerPadding: '15px',
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    centerMode: true,
                    infinite: true,
                    centerPadding: '15px',
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]
    });

    /**
     * Replace SVG images with inline SVG
     */
    jQuery('img.svg.category-icon').each(function () {
        var $img = jQuery(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        jQuery.get(imgURL, function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = jQuery(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }
            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');
            // Replace image with new SVG
            $img.replaceWith($svg);
        }, 'xml');
    });

    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    })

    // Handle close dropdown on click outside
    $(document).click(function(e) {
        if (!$(e.target).hasClass('button-size') &&
                !$(e.target).hasClass('flex-active-slide')
        ) {
            $(".button-size").removeClass('show');
            $(".dropdown-menu-size").removeClass('show');
        }
        if (!$(e.target).hasClass('button-extras') &&
                !$(e.target).hasClass('radiobox') &&
                !$(e.target).hasClass('extra') &&
                !$(e.target).hasClass('price') &&
                !$(e.target).hasClass('dropdown-item') &&
                !$(e.target).hasClass('flex-active-slide')
        ) {
            $(".button-extras").removeClass('show');
            $(".dropdown-menu-extras").removeClass('show');
        }
    });
})
